<template>
  <TableLayout :permissions="['business:member:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="编码" prop="id">
        <el-input v-model="searchForm.id" placeholder="请输入编码" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="创建时间" prop="createDate">
        <el-date-picker v-model="searchForm.createDate" value-format="yyyy-MM-dd" placeholder="请输入创建时间" @change="search"/>
      </el-form-item>
      <el-form-item label="创建人" prop="creator">
        <el-input v-model="searchForm.creator" placeholder="请输入创建人" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="编辑时间" prop="editDate">
        <el-date-picker v-model="searchForm.editDate" value-format="yyyy-MM-dd" placeholder="请输入编辑时间" @change="search"/>
      </el-form-item>
      <el-form-item label="编辑人" prop="editor">
        <el-input v-model="searchForm.editor" placeholder="请输入编辑人" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="是否已删除 0未删除 1已删除" prop="isdeleted">
        <el-input v-model="searchForm.isdeleted" placeholder="请输入是否已删除 0未删除 1已删除" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="info">
        <el-input v-model="searchForm.info" placeholder="请输入备注" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input v-model="searchForm.name" placeholder="请输入姓名" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="昵称" prop="nickname">
        <el-input v-model="searchForm.nickname" placeholder="请输入昵称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="openid" prop="openid">
        <el-input v-model="searchForm.openid" placeholder="请输入openid" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="状态 0正常 1禁用" prop="status">
        <el-input v-model="searchForm.status" placeholder="请输入状态 0正常 1禁用" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="unionid" prop="unionid">
        <el-input v-model="searchForm.unionid" placeholder="请输入unionid" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="注册来源 0微信小程序 1支付宝小程序" prop="origin">
        <el-input v-model="searchForm.origin" placeholder="请输入注册来源 0微信小程序 1支付宝小程序" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="账户余额（分）" prop="banlance">
        <el-input v-model="searchForm.banlance" placeholder="请输入账户余额（分）" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="注册时间" prop="registerDate">
        <el-date-picker v-model="searchForm.registerDate" value-format="yyyy-MM-dd" placeholder="请输入注册时间" @change="search"/>
      </el-form-item>
      <el-form-item label="最近租车时间" prop="lastRendId">
        <el-date-picker v-model="searchForm.lastRendId" value-format="yyyy-MM-dd" placeholder="请输入最近租车时间" @change="search"/>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="searchForm.phone" placeholder="请输入手机号" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="searchForm.email" placeholder="请输入邮箱" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input v-model="searchForm.password" placeholder="请输入密码" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="卡号" prop="cardNo">
        <el-input v-model="searchForm.cardNo" placeholder="请输入卡号" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="卡密" prop="cardSign">
        <el-input v-model="searchForm.cardSign" placeholder="请输入卡密" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="类型 0租客 1管理员" prop="type">
        <el-input v-model="searchForm.type" placeholder="请输入类型 0租客 1管理员" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="头像" prop="imgurl">
        <el-input v-model="searchForm.imgurl" placeholder="请输入头像" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:member:create']">
        <li><el-button type="primary" @click="$refs.operaMemberWindow.open('新建用户信息表')" icon="el-icon-plus" v-permissions="['business:member:create']">新建</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
      >
        <el-table-column prop="id" label="编码" min-width="100px"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" min-width="100px"></el-table-column>
        <el-table-column prop="creator" label="创建人" min-width="100px"></el-table-column>
        <el-table-column prop="editDate" label="编辑时间" min-width="100px"></el-table-column>
        <el-table-column prop="editor" label="编辑人" min-width="100px"></el-table-column>
        <el-table-column prop="isdeleted" label="是否已删除 0未删除 1已删除" min-width="100px"></el-table-column>
        <el-table-column prop="info" label="备注" min-width="100px"></el-table-column>
        <el-table-column prop="name" label="姓名" min-width="100px"></el-table-column>
        <el-table-column prop="nickname" label="昵称" min-width="100px"></el-table-column>
        <el-table-column prop="openid" label="openid" min-width="100px"></el-table-column>
        <el-table-column prop="status" label="状态 0正常 1禁用" min-width="100px"></el-table-column>
        <el-table-column prop="unionid" label="unionid" min-width="100px"></el-table-column>
        <el-table-column prop="origin" label="注册来源 0微信小程序 1支付宝小程序" min-width="100px"></el-table-column>
        <el-table-column prop="banlance" label="账户余额（分）" min-width="100px"></el-table-column>
        <el-table-column prop="registerDate" label="注册时间" min-width="100px"></el-table-column>
        <el-table-column prop="lastRendId" label="最近租车时间" min-width="100px"></el-table-column>
        <el-table-column prop="phone" label="手机号" min-width="100px"></el-table-column>
        <el-table-column prop="email" label="邮箱" min-width="100px"></el-table-column>
        <el-table-column prop="password" label="密码" min-width="100px"></el-table-column>
        <el-table-column prop="cardNo" label="卡号" min-width="100px"></el-table-column>
        <el-table-column prop="cardSign" label="卡密" min-width="100px"></el-table-column>
        <el-table-column prop="type" label="类型 0租客 1管理员" min-width="100px"></el-table-column>
        <el-table-column prop="imgurl" label="头像" min-width="100px"></el-table-column>
        <el-table-column
          v-if="containPermissions(['business:member:update', 'business:member:delete'])"
          label="操作"
          min-width="120"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaMemberWindow.open('编辑用户信息表', row)" icon="el-icon-edit" v-permissions="['business:member:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:member:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaMemberWindow ref="operaMemberWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaMemberWindow from '@/components/business/OperaMemberWindow'
export default {
  name: 'Member',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaMemberWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        id: '',
        createDate: '',
        creator: '',
        editDate: '',
        editor: '',
        isdeleted: '',
        info: '',
        name: '',
        nickname: '',
        openid: '',
        status: '',
        unionid: '',
        origin: '',
        banlance: '',
        registerDate: '',
        lastRendId: '',
        phone: '',
        email: '',
        password: '',
        cardNo: '',
        cardSign: '',
        type: '',
        imgurl: ''
      }
    }
  },
  created () {
    this.config({
      module: '用户信息表',
      api: '/business/member',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
</script>
